"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationEligibilities = void 0;
var CommunicationEligibilities;
(function (CommunicationEligibilities) {
    CommunicationEligibilities["callCenterAutoDialer"] = "callCenterAutoDialer";
    CommunicationEligibilities["lenderRemarketing"] = "lenderRemarketing";
    CommunicationEligibilities["remarketingEmail"] = "remarketingEmail";
    CommunicationEligibilities["remarketingSms"] = "remarketingSms";
    CommunicationEligibilities["sensitivePartner"] = "sensitivePartner";
    CommunicationEligibilities["transactionalEmail"] = "transactionalEmail";
    CommunicationEligibilities["transactionalSms"] = "transactionalSms";
})(CommunicationEligibilities || (exports.CommunicationEligibilities = CommunicationEligibilities = {}));
